export default __webpack_public_path__ + "static/media/number-shine-2.699b47b3.svg";